import { IsIn, ValidationOptions } from "class-validator";

export type StoryblokEnvironment = "published" | "draft";

const STORYBLOK_ENVIRONMENTS = [ "published", "draft" ] satisfies StoryblokEnvironment[];

export const IsStoryblokEnvironment = (
  validationOptions?: ValidationOptions,
): PropertyDecorator => IsIn(STORYBLOK_ENVIRONMENTS, validationOptions);
